var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "p",
    { staticClass: "pay-row", class: { sub: _vm.sub } },
    [_vm._v(" " + _vm._s(_vm.label) + " "), _c("w-spacer"), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }